import { useState, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export default function AuthGuard() {
  const [loading, setLoading] = useState(true);
  const [authed, setAuthed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const demoAccess = localStorage.getItem("lumaa_demo_access") === "1";
    if (demoAccess) {
      setAuthed(true);
      setLoading(false);
      return;
    }
    let active = true;
    supabase.auth.getSession().then(({ data }) => {
      if (!active) return;
      setAuthed(!!data.session);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);

  if (loading) {
    return (
      <div dir="rtl" className="flex h-screen w-full items-center justify-center bg-[#F0FDFD]">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#E4F5F5] border-t-[#00AAB7]" />
          <p className="text-sm text-ghasla-text-secondary">جارٍ التحميل...</p>
        </div>
      </div>
    );
  }

  if (!authed) {
    return <Navigate to="/auth/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}